import dayjs from "dayjs";

/**
 * Los rangos que ofrecen los atajos de «Traer históricos».
 *
 * Viven aparte del formulario porque decidir un rango de fechas no necesita
 * saber nada de tiendas, cajas ni aperturas, y probarlo dentro del componente
 * obligaba a simular media aplicación para comprobar dos fechas.
 */

/** Hoy: el mismo día en los dos extremos, no un rango hacia atrás. */
export const rangoDeHoy = () => {
  const hoy = dayjs();
  return { FechaInicio: hoy, FechaFin: hoy };
};

/** Los últimos `meses` meses, hasta hoy. */
export const rangoDeMeses = (meses) => ({
  FechaInicio: dayjs().subtract(meses, "month"),
  FechaFin: dayjs(),
});
